import { atomWithReset } from "jotai/utils";
import type { ReactChild } from "react";

export interface MLDialogParams {
  open?: boolean;
  title?: string;
  message?: ReactChild;
  isMobile?: boolean;
  onPositiveClick?: () => boolean | void; // return true for not closing modal
  onNegativeClick?: (() => boolean | void) | undefined; // return true for not closing modal
  positiveText?: string;
  negativeText?: string;
  positiveButton?: (onClick: any) => React.ReactElement<any, any>;
  negativeButton?: React.ReactElement<any, any>;
  exitText?: string;
  exitIcon?: JSX.Element;
  onExitClick?: (() => boolean | void) | undefined; // return true for not closing modal
}

export const snackBarStore = atomWithReset<MLDialogParams>({
  open: false,
  title: "",
  message: "",
  isMobile: false,
  onPositiveClick: () => false,
  // TODO se localizzo queste due stringhe crasha, Cannot read property 'strings' of undefined perchè non legge R
  positiveText: "Ok",
  negativeText: "Annulla",
  //@ts-ignore
  onNegativeClick: null,
  //@ts-ignore
  positiveButton: null,
  //@ts-ignore
  negativeButton: null,
  exitText: "",
  //@ts-ignore
  exitIcon: null,
});
